import { render, staticRenderFns } from "./teamChatUsersModal.vue?vue&type=template&id=2f4ca7d2&"
import script from "./teamChatUsersModal.vue?vue&type=script&lang=js&"
export * from "./teamChatUsersModal.vue?vue&type=script&lang=js&"
import style0 from "./teamChatUsersModal.vue?vue&type=style&index=0&id=2f4ca7d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports